import { createSelector } from "@ngrx/store";
import {
  RankingScope,
  RankingSelection,
} from "src/app/shared/interfaces/ranking-scope";
import { RankingCriteria } from "src/app/shared/models/ranking-criteria";
import { Guid } from "src/app/shared/types/guid";
import * as fromAccountStore from "src/app/store/reducers/account.reducer";
import * as fromRankingStore from "src/app/store/reducers/ranking.reducer";

type AccountState = { account: fromAccountStore.AccountState };
type RankingState = { ranking: fromRankingStore.RankingState };

const scopes = (state: RankingState) => state.ranking.scopes;
const criteria = (state: RankingState) => state.ranking.rankingCriteria;
const isTeacher = (state: AccountState) => state.account.member.is_teacher;

export function findGroupScope(
  scopes: Array<RankingScope>,
  groupId: Guid,
): RankingSelection {
  for (const organization of scopes) {
    for (const course of organization.courses) {
      const group = course.groups.find((group) => group.id === groupId);

      if (group) {
        return { organization, course, group };
      }
    }
  }

  return { organization: null, course: null, group: null };
}

export function resolveSelection(
  scopes: Array<RankingScope>,
  criteria: RankingCriteria,
): RankingSelection {
  if (criteria.group) {
    const selection = findGroupScope(scopes, criteria.group);

    if (selection.group) {
      return selection;
    }
  }

  const organization =
    scopes.find((organization) => organization.id === criteria.organization) ||
    scopes[0] ||
    null;
  const course =
    organization?.courses.find((course) => course.id === criteria.course) ||
    organization?.courses[0] ||
    null;

  return { organization, course, group: null };
}

export const selectSelection = createSelector(
  scopes,
  criteria,
  resolveSelection,
);

export const selectGroupLink = createSelector<
  AccountState | RankingState,
  [RankingSelection, boolean],
  Array<string> | null
>(selectSelection, isTeacher, (selection, isTeacher) =>
  selection.group
    ? [
        isTeacher ? "/teacher/courses" : "/student/courses",
        selection.course.id,
        "groups",
        selection.group.id,
      ]
    : null,
);
